module.exports = __webpack_public_path__ + "static/media/bg19.9ef610fe.png";